import { Products } from "@/components/site/Products";

export default function Collection() {
  return (
    <main data-testid="collection-page" className="pt-28 lg:pt-36">
      <Products />
    </main>
  );
}
